import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateResumeSummaryMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeInput;
}>;


export type UpdateResumeSummaryMutation = { __typename?: 'Mutation', updateJobSeekerProfileResume?: { __typename?: 'UpdateJobSeekerProfileResumePayload', resume?: { __typename?: 'JobSeekerProfileResume', id: string, summary?: string | null } | null } | null };

export type AddResumeSkillsMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeSkillsInput;
}>;


export type AddResumeSkillsMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeSkills?: { __typename?: 'AddJobSeekerProfileResumeSkillsPayload', skills: Array<{ __typename?: 'JobSeekerProfileSkill', id: string, text?: string | null }> } | null };

export type DeleteResumeSkillsMutationVariables = Types.Exact<{
  input: Types.DeleteJobSeekerProfileResumeSkillsInput;
}>;


export type DeleteResumeSkillsMutation = { __typename?: 'Mutation', deleteJobSeekerProfileResumeSkills?: { __typename?: 'DeleteJobSeekerProfileResumeSkillsPayload', skillIds: Array<string> } | null };

export type UpdateResumeWorkExperiencesMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeWorkExperiencesInput;
}>;


export type UpdateResumeWorkExperiencesMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeWorkExperiences?: { __typename?: 'UpdateJobSeekerProfileResumeWorkExperiencesPayload', workExperiences: Array<{ __typename?: 'JobSeekerProfileWorkExperience', id: string, description?: string | null }> } | null };

export type AddResumeWorkExperiencesMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeWorkExperiencesInput;
}>;


export type AddResumeWorkExperiencesMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeWorkExperiences?: { __typename?: 'AddJobSeekerProfileResumeWorkExperiencesPayload', workExperiences: Array<{ __typename?: 'JobSeekerProfileWorkExperience', id: string, description?: string | null }> } | null };


export const UpdateResumeSummaryDocument = gql`
    mutation UpdateResumeSummary($input: UpdateJobSeekerProfileResumeInput!) {
  updateJobSeekerProfileResume(input: $input) {
    resume {
      id
      summary
    }
  }
}
    `;
export type UpdateResumeSummaryMutationFn = Apollo.MutationFunction<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>;

/**
 * __useUpdateResumeSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateResumeSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeSummaryMutation, { data, loading, error }] = useUpdateResumeSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>(UpdateResumeSummaryDocument, options);
      }
export type UpdateResumeSummaryMutationHookResult = ReturnType<typeof useUpdateResumeSummaryMutation>;
export type UpdateResumeSummaryMutationResult = Apollo.MutationResult<UpdateResumeSummaryMutation>;
export type UpdateResumeSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateResumeSummaryMutation, UpdateResumeSummaryMutationVariables>;
export const AddResumeSkillsDocument = gql`
    mutation AddResumeSkills($input: AddJobSeekerProfileResumeSkillsInput!) {
  addJobSeekerProfileResumeSkills(input: $input) {
    skills {
      id
      text
    }
  }
}
    `;
export type AddResumeSkillsMutationFn = Apollo.MutationFunction<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>;

/**
 * __useAddResumeSkillsMutation__
 *
 * To run a mutation, you first call `useAddResumeSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeSkillsMutation, { data, loading, error }] = useAddResumeSkillsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeSkillsMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>(AddResumeSkillsDocument, options);
      }
export type AddResumeSkillsMutationHookResult = ReturnType<typeof useAddResumeSkillsMutation>;
export type AddResumeSkillsMutationResult = Apollo.MutationResult<AddResumeSkillsMutation>;
export type AddResumeSkillsMutationOptions = Apollo.BaseMutationOptions<AddResumeSkillsMutation, AddResumeSkillsMutationVariables>;
export const DeleteResumeSkillsDocument = gql`
    mutation DeleteResumeSkills($input: DeleteJobSeekerProfileResumeSkillsInput!) {
  deleteJobSeekerProfileResumeSkills(input: $input) {
    skillIds
  }
}
    `;
export type DeleteResumeSkillsMutationFn = Apollo.MutationFunction<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>;

/**
 * __useDeleteResumeSkillsMutation__
 *
 * To run a mutation, you first call `useDeleteResumeSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResumeSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResumeSkillsMutation, { data, loading, error }] = useDeleteResumeSkillsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteResumeSkillsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>(DeleteResumeSkillsDocument, options);
      }
export type DeleteResumeSkillsMutationHookResult = ReturnType<typeof useDeleteResumeSkillsMutation>;
export type DeleteResumeSkillsMutationResult = Apollo.MutationResult<DeleteResumeSkillsMutation>;
export type DeleteResumeSkillsMutationOptions = Apollo.BaseMutationOptions<DeleteResumeSkillsMutation, DeleteResumeSkillsMutationVariables>;
export const UpdateResumeWorkExperiencesDocument = gql`
    mutation UpdateResumeWorkExperiences($input: UpdateJobSeekerProfileResumeWorkExperiencesInput!) {
  updateJobSeekerProfileResumeWorkExperiences(input: $input) {
    workExperiences {
      id
      description
    }
  }
}
    `;
export type UpdateResumeWorkExperiencesMutationFn = Apollo.MutationFunction<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>;

/**
 * __useUpdateResumeWorkExperiencesMutation__
 *
 * To run a mutation, you first call `useUpdateResumeWorkExperiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeWorkExperiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeWorkExperiencesMutation, { data, loading, error }] = useUpdateResumeWorkExperiencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeWorkExperiencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>(UpdateResumeWorkExperiencesDocument, options);
      }
export type UpdateResumeWorkExperiencesMutationHookResult = ReturnType<typeof useUpdateResumeWorkExperiencesMutation>;
export type UpdateResumeWorkExperiencesMutationResult = Apollo.MutationResult<UpdateResumeWorkExperiencesMutation>;
export type UpdateResumeWorkExperiencesMutationOptions = Apollo.BaseMutationOptions<UpdateResumeWorkExperiencesMutation, UpdateResumeWorkExperiencesMutationVariables>;
export const AddResumeWorkExperiencesDocument = gql`
    mutation AddResumeWorkExperiences($input: AddJobSeekerProfileResumeWorkExperiencesInput!) {
  addJobSeekerProfileResumeWorkExperiences(input: $input) {
    workExperiences {
      id
      description
    }
  }
}
    `;
export type AddResumeWorkExperiencesMutationFn = Apollo.MutationFunction<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>;

/**
 * __useAddResumeWorkExperiencesMutation__
 *
 * To run a mutation, you first call `useAddResumeWorkExperiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeWorkExperiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeWorkExperiencesMutation, { data, loading, error }] = useAddResumeWorkExperiencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeWorkExperiencesMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>(AddResumeWorkExperiencesDocument, options);
      }
export type AddResumeWorkExperiencesMutationHookResult = ReturnType<typeof useAddResumeWorkExperiencesMutation>;
export type AddResumeWorkExperiencesMutationResult = Apollo.MutationResult<AddResumeWorkExperiencesMutation>;
export type AddResumeWorkExperiencesMutationOptions = Apollo.BaseMutationOptions<AddResumeWorkExperiencesMutation, AddResumeWorkExperiencesMutationVariables>;